import { RouteRecordRaw } from 'vue-router';
import baseRoutes from '@src/router/route.base';
import PageLayoutContainer from '@src/components/layout/Layout.vue';

export const menuRoutes: RouteRecordRaw[] = [
    {
        name: 'ai-librarian',
        path: '/ai-librarian',
        redirect: { name: 'librarian-home' },
        children: [
            {
                name: 'librarian-home',
                path: 'home',
                meta: { title: '首页', activeKey: 'home' },
                component: () => import('@src/pages/ai-librarian/home.vue'),
            },
            {
                name: 'librarian-dialogue',
                path: 'librarian-dialogue',
                meta: { title: '对话', activeKey: 'dialogue' },
                component: () => import('@src/pages/ai-librarian.vue'),
            },
            {
                name: 'librarian-books',
                path: 'librarian-books',
                meta: { title: '关键字查询', activeKey: 'books' },
                component: () => import('@src/pages/ai-librarian/keyword-books.vue'),
            }
        ],  
    }
];

const router: RouteRecordRaw[] = [
    {
        path: '/',
        component: PageLayoutContainer,
        redirect: { name: 'ai-librarian' },
        children: [
            ...menuRoutes,
            {
                name: 'large-screen',
                path: '/large-screen',
                redirect: { name: 'large-screen-home' },
                children: [
                    {
                        name: 'large-screen-home',
                        path: 'large-screen-home',
                        meta: { title: '首页', activeKey: 'home' },
                        component: () => import('@src/pages/ai-librarian/large-screen-home.vue'),
                    },
                    {
                        name: 'large-screen-chat',
                        path: 'large-screen-chat',
                        meta: { title: '对话', activeKey: 'dialogue' },
                        component: () => import('@src/pages/ai-librarian/large-screen-chat.vue'),
                    },
                    {
                        name: 'large-screen-books',
                        path: 'large-screen-books',
                        meta: { title: '关键字查询', activeKey: 'books' },
                        component: () => import('@src/pages/ai-librarian/keyword-books.vue'),
                    }
                ],
            }
        ],
    },
    ...baseRoutes,
    {
        name: 'studying-companion',
        path: '/studying-companion',
        redirect: { name: 'companion-home' },
        component: () => import('@src/pages/studying-companion.vue'),
        children: [
            {
                name: 'companion-home',
                path: 'companion-home',
                meta: { title: '首页', activeKey: 'home' },
                component: () => import('@src/pages/studying-companion/home.vue'),
            },
            {
                name: 'companion-dialogue',
                path: 'companion-dialogue',
                meta: { title: '对话', activeKey: 'dialogue' },
                component: () => import('@src/pages/studying-companion/companion-dialogue.vue'),
            }
        ],
    },
    {
        path: '/:w*',
        redirect: {
            name: 'ai-librarian',
        },
    },
]

export default router;